import React from 'react';
import { parseLatex } from '../parser/parse'; // Parses LaTeX tokens into AST JSON
import { renderLatexAST } from './renderLatex'; // Render AST to HTML

interface LatexRendererProps {
    latex: string;
    color?: string;
}

const LatexRenderer: React.FC<LatexRendererProps> = ({ latex, color = 'inherit' }) => {
    let rendered;
    try {
        const parsed = parseLatex(latex);
        rendered = renderLatexAST(parsed);
    } catch {
        rendered = <span style={{ color: 'red' }}>Error rendering</span>;
    }

    return (
        <span className="latex-wrapper" style={{ color }}>
            {rendered}
        </span>
    );
};

export default LatexRenderer;
